module.exports = __webpack_public_path__ + "d2fa1db5627fc9b05115226ace5b8e97.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_1-420.jpg
// module id = 283
// module chunks = 0